import { render, staticRenderFns } from "./IncomingCall.vue?vue&type=template&id=5b4f4ac9"
import script from "./IncomingCall.vue?vue&type=script&lang=js"
export * from "./IncomingCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports